import { enums } from '@adc/sdk'

/* istanbul ignore file */
// Third party provded Survey monkey script
// creates a survey form in the DOM and sets a cookie
// will not display the form a second time if the cookie is set
export const runSurveyMonkeyScript = (onSurveyClose, viewFrom) => {
  ;(function (t, e, s, o) {
    const source =
      viewFrom === enums.CurrentTargetAudience.Buyer
        ? 'https://widget.surveymonkey.com/collect/website/js/tRaiETqnLgj758hTBazgd0zO8UO_2FEJ7AOu7T0CjpbqAIpxkyu1zpj8n4vWI3nC15.js'
        : 'https://widget.surveymonkey.com/collect/website/js/tRaiETqnLgj758hTBazgdyH6IxSs9l0Sxhopju3T8iXJeHpwZtcLn6GbcMHkKBdu.js'

    const existingScript = e.getElementById(o)
    if (existingScript) {
      existingScript.remove()
    }

    t.SMCX = t.SMCX || []
    const n = e.getElementsByTagName(s)
    const c = n[n.length - 1]
    const l = e.createElement(s)
    l.type = 'text/javascript'
    l.async = true
    l.id = o
    l.src = source
    c.parentNode.insertBefore(l, c)
    l.onload = () => setCloseButtonListener(onSurveyClose)
  })(window, document, 'script', 'smcx-sdk')
}

const getCloseButton = () =>
  document.getElementsByClassName('smcx-modal-close')?.[0]

const setCloseButtonListener = onSurveyClose => {
  let closeButton
  closeButton = getCloseButton()
  if (!closeButton) {
    const interval = setInterval(() => {
      closeButton = getCloseButton()
      if (closeButton) {
        clearInterval(interval)
        closeButton.addEventListener('click', () => {
          onSurveyClose()
        })
      }
    }, 500)
  }
}

export const collectorId = 454811600
export const surveyCookieName = `smcx_${collectorId}_last_shown_at`
